import React from "react";
import config from "../../../config/domain";

import { Link, NavLink } from "react-router-dom";
import { RoutesUrl } from "../../Routes/constents";

const HeaderUnTnc = ({ logout, isNavbar, showNavbar }) => {
  return (
    <>
      <div className="navbar-menu">
        <div className={isNavbar ? "mobileView" : "hide_nav"}>
          <div>
            <ul onClick={showNavbar}>
              <li className="nav-sub-container">
                <a href="javascript:void(0)">
                  Documentation
                  <ul className="nav-sublink">
                    <li>
                      <a
                        target="_blank"
                        rel="noreferrer"
                        href={config.jmw_client_docs}
                      >
                        Client Documentation
                      </a>
                    </li>
                    <li>
                      <a
                        target="_blank"
                        rel="noreferrer"
                        href={config.jmw_partner_docs}
                      >
                        Partner Documentation
                      </a>
                    </li>
                  </ul>
                </a>
              </li>
              <li>
                <NavLink exact activeClassName="active" to={RoutesUrl.Resouces}>
                  Resources
                </NavLink>
              </li>
              <li>
                <NavLink exact activeClassName="active" to={RoutesUrl.Support}>
                  Support
                </NavLink>
              </li>
              <li onClick={logout}>
                <NavLink to="#">
                  <i className="edel-icon-logout"></i> Logout
                </NavLink>
              </li>
              <li>
                <NavLink
                  exact
                  activeClassName="active"
                  to={RoutesUrl.TermsAndConditions}
                  className="btn"
                >
                  Get Started
                </NavLink>
              </li>
            </ul>
          </div>
        </div>
        <ul className="destopView">
          <li className="nav-sub-container">
            <a>Documentation</a>
            <ul className="nav-sublink">
              <li>
                <a
                  target="_blank"
                  rel="noreferrer"
                  href={config.jmw_client_docs}
                >
                  Client Documentation
                </a>
              </li>
              <li>
                <a
                  target="_blank"
                  rel="noreferrer"
                  href={config.jmw_partner_docs}
                >
                  Partner Documentation
                </a>
              </li>
            </ul>
          </li>
          <li>
            <NavLink exact activeClassName="active" to={RoutesUrl.Resouces}>
              Resources
            </NavLink>
          </li>
          <li>
            <NavLink exact activeClassName="active" to={RoutesUrl.Support}>
              Support
            </NavLink>
          </li>

          <li>
            <NavLink
              exact
              activeClassName="active"
              to={RoutesUrl.TermsAndConditions}
              className="btn"
            >
              Get Started
            </NavLink>
          </li>
          <li onClick={logout}>
            <Link to="#">
              <i className="edel-icon-logout"></i>
              Logout
            </Link>
          </li>
        </ul>
      </div>
    </>
  );
};

export default HeaderUnTnc;
